import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import i18n from '@/i18n';

/**
 * Ensure that a value is provided
 */
extend('required', {
  ...required,
  message: i18n.t('forms.rules.required'),
});

/**
 *
 */
extend('phone', {
  validate(value) {
    return value && value.length === 13 && /^00?\d*$/.test(value);
  },
  message: i18n.t('forms.rules.phone'),
});
